const PIXEL_ID = '1017174521133265'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

let initialized = false

export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod(...args)
      } else {
        fbq!.queue!.push(args)
      }
    } as Window['fbq']

    fbq!.queue = []
    fbq!.loaded = true
    fbq!.version = '2.0'
    fbq!.push = fbq
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq!('init', PIXEL_ID)
  window.fbq!('track', 'PageView')

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.alt = ''
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

export function trackInitiateCheckout(plan: string, value: number): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'InitiateCheckout', {
    content_name: plan,
    value,
    currency: 'ARS',
  })
}
